import styles from './BadgeCambiosSinGuardar.module.css';

interface Props {
  /** Normalmente el `hayCambios` de useCambiosSinGuardar. */
  visible: boolean;
  texto?: string;
}

/**
 * Variante inline del aviso de cambios pendientes: un badge para poner junto al
 * botón Guardar de una sección.
 *
 * Cuándo usar cada variante:
 *   - BarraCambiosSinGuardar → formularios de página con UN solo guardado.
 *     Reemplaza al botón del formulario.
 *   - BadgeCambiosSinGuardar → pantallas con varias secciones que se guardan
 *     por separado (p. ej. Config IA) o editores anidados, donde una barra fija
 *     no podría indicar qué sección se está guardando y además se solaparía con
 *     la barra de la página contenedora. Acompaña al botón, no lo reemplaza.
 */
export default function BadgeCambiosSinGuardar({
  visible,
  texto = 'Sin guardar',
}: Props) {
  if (!visible) return null;

  return (
    <span className={styles.badge} role="status" aria-live="polite">
      <span className={styles.punto} aria-hidden="true" />
      {texto}
    </span>
  );
}
